import { render } from "./product-gallery-carousel.vue?vue&type=template&id=aaff9aa0"
import script from "./product-gallery-carousel.vue?vue&type=script&lang=js"
export * from "./product-gallery-carousel.vue?vue&type=script&lang=js"

import "./product-gallery-carousel.vue?vue&type=style&index=0&id=aaff9aa0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__